import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-fahrzeugtyp-list-view',
  imports: [],
  templateUrl: './fahrzeugtyp.list-view.html',
  styleUrls: ['./fahrzeugtyp.list-view.css'],
})
export class FahrzeugtypListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
